<template>
    <router-view class="container"></router-view>
</template>

<script>
export default {
    name: 'DefaultRegistration',
}
</script>

<style>

</style>
